<template>
  <div>
    <div class="flex-right">
      <h2 v-if="$route.query.isEditingNewStudent">新建学生</h2>
      <div class="flex-right-flex1"></div>
      <Button type="primary" @click="save">保存</Button>
    </div>
    <Card class="one-card">
      <h2 slot="title">学生基本信息</h2>
      <i-form :model="data" label-position="top">
        <Row :gutter="16">
          <i-col span="6">
            <FormItem label="Name">
              <i-input v-model="data.name"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Former Name">
              <i-input v-model="data.former_name"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Date of Birth">
              <DatePicker
                type="date"
                placeholder="选择出生日期"
                style="width: 100%"
                v-model="data.date_of_birth"
              ></DatePicker>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Gender">
              <Select v-model="data.gender" style="width: 100%">
                <Option :value="1">男</Option>
                <Option :value="0">女</Option>
              </Select>
            </FormItem>
          </i-col>
          <i-col span="12">
            <FormItem
              label="Place of Birth(Place of Birth(City/Province/Country)"
            >
              <i-input v-model="data.place_of_birth"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Religious Preference">
              <i-input v-model="data.religious_preference"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Nationality">
              <i-input v-model="data.nationality"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Penmanent Residency/Green Card">
              <i-input v-model="data.penmanent_residency"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Military Status">
              <i-input v-model="data.military_status"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Race">
              <i-input v-model="data.race"></i-input>
            </FormItem>
          </i-col>
        </Row>
      </i-form>
    </Card>
    <Card class="one-card">
      <h2 slot="title">联系方式</h2>
      <i-form :model="data" label-position="top">
        <Row :gutter="16">
          <i-col span="6">
            <FormItem label="Mobile Phone">
              <i-input v-model="data.mobile_phone"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Alternate Phone">
              <i-input v-model="data.alternate_phone"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="E-mail">
              <i-input v-model="data.email"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Wechat">
              <i-input v-model="data.wechat"></i-input>
            </FormItem>
          </i-col>
          <i-col span="24">
            <FormItem label="Permanent Address">
              <i-input v-model="data.permanent_address"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="Native Language">
              <i-input v-model="data.native_language"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="Other Language(s)">
              <i-input v-model="data.other_languages"></i-input>
            </FormItem>
          </i-col>
        </Row>
      </i-form>
    </Card>

    <Card class="one-card">
      <h2 slot="title">签证信息</h2>
      <i-form :model="data" label-position="top">
        <Row :gutter="16">
          <i-col span="6">
            <FormItem label="Passport No.">
              <i-input v-model="data.passport_number"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Date of issue">
              <DatePicker
                type="date"
                placeholder="选择日期"
                style="width: 100%"
                v-model="data.date_of_issue"
              ></DatePicker>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Current US Visa">
              <i-input v-model="data.current_US_visa"></i-input>
            </FormItem>
          </i-col>
          <i-col span="6">
            <FormItem label="Current US Visa No.">
              <i-input v-model="data.current_US_visa_number"></i-input>
            </FormItem>
          </i-col>
          <i-col span="24">
            <FormItem label="Number of years you have lived in US">
              <i-input v-model="data.number_of_years_lived_in_US"></i-input>
            </FormItem>
          </i-col>
        </Row>
      </i-form>
    </Card>

    <Card class="one-card">
      <h2 slot="title">爱好</h2>
      <i-form :model="data" label-position="top">
        <Row :gutter="16">
          <i-col span="8">
            <FormItem label="爱好1">
              <i-input v-model="data.hobbies"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="爱好2">
              <i-input v-model="data.hobbies2"></i-input>
            </FormItem>
          </i-col>
          <i-col span="8">
            <FormItem label="爱好3">
              <i-input v-model="data.hobbies3"></i-input>
            </FormItem>
          </i-col>
        </Row>
      </i-form>
    </Card>

    <div class="flex-right">
      <Button type="primary" @click="save">保存</Button>
    </div>
  </div>
</template>

<script>
import bus from "@/bus.js";
export default {
  data() {
    return {
      data: {},
    };
  },
  methods: {
    async getData() {
      if (!this.$store.getters.selectedStudent._id) {
        this.data = {};
        return;
      }
      let res = await this.api({
        url: "/student/getBasicInfoById",
        method: "get",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
        },
      });

      this.data = res;
    },

    async save() {
      await this.api({
        url: "/student/save",
        method: "post",
        params: {
          token: this.$store.getters.token,
          ttoken: this.$store.getters.ttoken,
          student_id: this.$store.getters.selectedStudent._id,
        },
        data: {
          _id: this.$store.getters.selectedStudent._id,
          ...this.data,
          date_of_birth: this.$moment(this.data.date_of_birth).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
          date_of_issue: this.$moment(this.data.date_of_issue).format(
            "YYYY-MM-DD HH:mm:ss"
          ),
        },
      });

      this.$Message.success("更新成功");

      if (this.$route.query.isEditingNewStudent) {
        this.$router.push({
          path: "/student",
        });
        bus.$emit("reloadStudentList");
      }
    },
  },
  mounted() {
    if (!this.$store.getters.selectedStudent._id) {
      return;
    }
    this.getData();
  },
  watch: {
    "$store.getters.selectedStudent": function () {
      this.getData();
    },
    "$route.query.isEditingNewStudent": function () {
      this.$nextTick(() => {
        this.getData();
      });
    },
  },
};
</script>

<style scoped lang="less">
h2 {
  margin: 0;
  font-size: 24px;
  font-weight: bolder;
}
.one-card {
  margin-bottom: 20px;
}
</style>